import { ErrorResponse, OperationTypeEnum, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllSkuResponseModel, SkuPercentageDto, SkuPercentagesResponseModel, SkuResponseModel,CommonResponse,SkuDetailsResponseModel, SoakTypeRequest, Type1Dto } from '@gtpl/shared-models/masters';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { Raw, Repository, getManager } from 'typeorm';
import { GetValueAdditionDataBySkuCodesRequest } from './dto/get-valu-addition-data-by-sku-codes.request';
import { SkuCodesAdapter } from './dto/sku-codes.adapter';
import { SkuCodesDTO } from './dto/sku-codes.dto';
import { SkuCodesRequest } from './dto/sku-codes.request';
import { SkuDataRequest } from './dto/sku-data-request';
import { SkuCodes } from './sku-codes.entity';
import {SkuDetails} from './dto/sku_details.dto';
import { SkuCodesDetail } from './sku-details.entity';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import appSettings from 'apps/services/config';
import { ValueAddition1TypesService } from '../value-addition1-types/value-addition1-types.service';
import { Type1Service } from 'libs/shared-services/masters/src/lib/addition1-service';


@Injectable()
export class SkuCodesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(SkuCodes)
        private skuCodesRepository: Repository<SkuCodes>,
        @InjectRepository(SkuCodesDetail)
        private skudetailsRepo: Repository<SkuCodesDetail>,
        private skuCodesAdapter: SkuCodesAdapter,
        private valueAdditionService : Type1Service
    ) { }
    /**
     * Create Or Update Sku Code
     * @param skuCodesDTO 
     * @param isUpdate 
     * @param request 
     */
    async createSkuCode(skuCodesDTO: SkuCodesDTO, isUpdate: boolean, request: Request): Promise<SkuResponseModel> {
        console.log(skuCodesDTO,'dto',isUpdate,'isUPdate')
        try {
            //creating short code as value addition one and saving that id as value addition one id in SKU master.
            const valueAdditionOneDTO = new Type1Dto(0,skuCodesDTO.shortCode,skuCodesDTO.shortCode,'',skuCodesDTO.createdUser,skuCodesDTO.updatedUser,true);
            valueAdditionOneDTO.name = skuCodesDTO.shortCode;
            valueAdditionOneDTO.code = skuCodesDTO.shortCode;
            valueAdditionOneDTO.createdUser = isUpdate?skuCodesDTO.updatedUser:skuCodesDTO.createdUser;
            const createValueAddition = await this.valueAdditionService.createShortCodeAsVA1(valueAdditionOneDTO)
            console.log(createValueAddition,'createValueAddition')
            if(createValueAddition.status){
                skuCodesDTO.valueAdditionOneId = createValueAddition.intlCode == 100 ? createValueAddition.data[0].valueAdditionOneId : createValueAddition.data.valueAdditionOneId
            }else{
                throw new SkuResponseModel(false,11104, 'Something went wrong while creating Value Addition');
            }
            let previousValue;
            // to check whether Sku Code exists with the passed  Sku Code  or not. if isUpdate is false, a check will be done whether a record with the passed Sku Code is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Sku Code  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const SkuCodeEntity = await this.getSkuCodeDetailsWithoutRelations(skuCodesDTO.variantCode);
                if (SkuCodeEntity) {
                    throw new SkuResponseModel(false,11104, 'Same Product already exists');
                }
                // var notificationStatus='Created';
                const existingShortCode = await this.skuCodesRepository.findOne({
                    where: {
                        shortCode: skuCodesDTO.shortCode
                    }
                });

                if (existingShortCode) {
                    throw new SkuResponseModel(
                        false,
                        11104,
                        'Product already exists'
                    );
                }

                // const existingCombination = await this.skuCodesRepository.findOne({
                //     where: {
                //         productId: skuCodesDTO.productId,
                //         productCount: skuCodesDTO.productCount,
                //         countType: skuCodesDTO.countType,
                //         shortCode: skuCodesDTO.shortCode
                //     }
                // });

                // if (existingCombination) {
                //     throw new SkuResponseModel(
                //         false,
                //         11104,
                //         'SKU already exists with same Product, Count Type, Count and Short Code'
                //     );
                // }

            }
            if (isUpdate) {
                const certificatePrevious = await this.skuCodesRepository.findOne({where:{skuCodeId:skuCodesDTO.skuCodeId}})
                previousValue = certificatePrevious.variantCode+','+certificatePrevious.productId;
                const SkuCodeEntity = await this.getSkuCodeDetailsWithoutRelations(skuCodesDTO.variantCode);
                if(SkuCodeEntity){
                if (SkuCodeEntity.skuCodeId!=skuCodesDTO.skuCodeId) {
                    throw new SkuResponseModel(false,11104, 'Same Product already exists');
                }
                
            }
                // var notificationStatus='Created';
                const existingShortCode = await this.skuCodesRepository.findOne({
                    where: {
                        shortCode: skuCodesDTO.shortCode
                    }
                });

                if (existingShortCode) {
                    if (existingShortCode.skuCodeId != skuCodesDTO.skuCodeId) {
                        throw new SkuResponseModel(
                            false,
                            11104,
                            'Product already exists'
                        );
                    }
                }

                // const existingCombination = await this.skuCodesRepository.findOne({
                //     where: {
                //         productId: skuCodesDTO.productId,
                //         productCount: skuCodesDTO.productCount,
                //         countType: skuCodesDTO.countType,
                //         shortCode: skuCodesDTO.shortCode
                //     }
                // });

                // if (existingCombination) {
                //     if (existingCombination.skuCodeId != skuCodesDTO.skuCodeId) {
                //         throw new SkuResponseModel(
                //             false,
                //             11104,
                //             'SKU already exists with same Product, Count Type, Count and Short Code'
                //         );
                //     }
                // }
            }
            // else{
            // var notificationStatus='Updated';
            // }
            const convertedSkuCodeEntity: SkuCodes = this.skuCodesAdapter.convertDtoToEntity(skuCodesDTO, isUpdate);
            console.log(convertedSkuCodeEntity,'entity');
            const savedSkuCodeEntity: SkuCodes = await this.skuCodesRepository.save(
                convertedSkuCodeEntity
            );

            const savedSkuCodeDto: SkuCodesDTO = this.skuCodesAdapter.convertEntityToDto(savedSkuCodeEntity);
            if (savedSkuCodeDto) {
                const present = savedSkuCodeDto.variantCode+","+savedSkuCodeDto.productId
                // generating resposnse
                const response = new SkuResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Sku Code Updated Successfully' : 'Sku Code Created Successfully', savedSkuCodeDto);
            //   const name=isUpdate?'updated':'created'
            //   const display = isUpdate?'Sku Code Updated Successfully' : 'Sku Code Created Successfully'
            //   const user =isUpdate?savedSkuCodeDto.updatedUser:savedSkuCodeDto.createdUser
            // const newLogDto = new LogsDto(1,name, 'SkuCodes', savedSkuCodeDto.skuCodeId, true, display,user,previousValue,present)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
                return response;
            } else {
                throw new SkuResponseModel(false,11106, 'Sku Code saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * check Sku COde Exist
     * @param skuCode 
     */
    async getSkuCodeDetailsWithoutRelations(variantCode: string): Promise<SkuCodes> {
        // tslint:disable-next-line: typedef
        const SkuCodeResponse = await this.skuCodesRepository.findOne({
            where: { variantCode: Raw(alias => `variant_code = '${variantCode}'`) },
        });
        if (SkuCodeResponse) {
            return SkuCodeResponse;
        } else {
            return null;
        }
    }

    
    /**
     * get All Sku COdes
     */
    async getAllSkuCodes(req?:UserRequestDto): Promise<AllSkuResponseModel> {
        // const page: number = 1;
        try {
            const skuCodesDTO: SkuCodesDTO[] = [];
            //retrieves all companies
            const skuCodesEntities: SkuCodes[] = await this.skuCodesRepository.createQueryBuilder("sku_codes")
                .select(["food_types.food_type as foodType,value_addition_one_types.name as valueAdd1Name,value_addition_two_types.name as valueAdd2Name,value_addition_three_types.name as valueAdd3Name,value_addition_four_types.name as valueAdd4Name,value_addition_five_types.name as valueAdd5Name, sku_codes.sku_code_id as skuCodeId,sku_codes.food_type_id as foodTypeId,sku_codes.value_addition_one_id as valueAdditionOneId,sku_codes.value_addition_two_id as valueAdditionTwoId,sku_codes.value_addition_three_id as valueAdditionThreeId,sku_codes.value_addition_four_id as valueAdditionFourId,sku_codes.value_addition_five_id as valueAdditionFiveId,sku_codes.variant_code as variantCode,sku_codes.only_salt as onlySalt,sku_codes.sttp_salt as sttpSalt,sku_codes.np_salt as npSalt,sku_codes.cp_salt as cpSalt,sku_codes.is_active as isActive,sku_codes.created_at as createdAt,sku_codes.created_user as createdUser,sku_codes.updated_at as updatedAt,sku_codes.updated_user as updatedUser,sku_codes.version_flag as versionFlag,products.name as productName,sku_codes.product_id as productId,grades.grade_name as gradeName,sku_codes.grade_id as gradeId,sku_codes.min_count as minCount,sku_codes.max_count as maxCount,sku_codes.required_count as requiredCount,sku_codes.min_glaze as minglaze,sku_codes.max_glaze as maxglaze,sku_codes.soaking_style as soakingStyle,sku_codes.soaking_time as soakingTime,sku_codes.loss_or_gain_percentage as lossOrGainPercentage,sku_codes.unit_price as unitPrice,sic.category as vendorCategory, sku_codes.short_code as shortCode, sku_codes.type_of_supply as typeOfSupply, sku_codes.soaking_yield as soakingYield, sku_codes.taxability_type as  taxabilityType, sku_codes.hon_hl_yield as honHlYield, sku_codes.hl_to_peeling_yield as hlToPeelingYield , sku_codes.cooking_less_yield as cookingLessYield, t.tax_name as taxName,sku_codes.count_type as countType,sku_codes.product_count as productCount"])
                .leftJoin("food_types", "food_types", "food_types.food_type_id = sku_codes.food_type_id")
                .leftJoin("value_addition_one_types", "value_addition_one_types", "value_addition_one_types.value_addition_one_id = sku_codes.value_addition_one_id")
                .leftJoin("value_addition_two_types", "value_addition_two_types", "value_addition_two_types.value_addition_two_id = sku_codes.value_addition_two_id")
                .leftJoin("value_addition_three_types", "value_addition_three_types", "value_addition_three_types.value_addition_three_id = sku_codes.value_addition_three_id")
                .leftJoin("value_addition_four_types", "value_addition_four_types", "value_addition_four_types.value_addition_four_id = sku_codes.value_addition_four_id")
                .leftJoin("value_addition_five_types", "value_addition_five_types", "value_addition_five_types.value_addition_five_id = sku_codes.value_addition_five_id")
                .leftJoin("products","products","products.product_id = sku_codes.product_id")
                .leftJoin("grades","grades","grades.grade_id = sku_codes.grade_id")
                .leftJoin("stock_item_categories","sic","sic.id = sku_codes.category_id")
                .leftJoin("taxes","t","t.tax_id = sku_codes.tax_id")
                .orderBy("sku_codes.variant_code")
                .getRawMany();
            //console.log(skuCodesEntities);
            if (skuCodesEntities) {
                // converts the data fetched from the database which of type companies array to type SkuCodeseDto array.
                skuCodesEntities.forEach(skuCodeEntity => {
                    const convertedskuCodesDto: SkuCodesDTO = this.skuCodesAdapter.convertEntityToDto(
                        skuCodeEntity
                    );
                    skuCodesDTO.push(convertedskuCodesDto);
                });
                const response = new AllSkuResponseModel(true, 11108, "Sku Codes retrieved successfully", skuCodesEntities);
                // const newLogDto = new LogsDto(1,'view all sku codes', 'SkuCodes', 0, true, 'Sku Codes retrieved successfully',req.createdUser)
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return response;
            } else {
                throw new AllSkuResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getAllActiveSkuCodes(): Promise<AllSkuResponseModel> {
        // const page: number = 1;
        try {
            const skuCodesDTO: SkuCodesDTO[] = [];
            //retrieves all companies
            const skuCodesEntities: SkuCodes[] = await this.skuCodesRepository.find({ order: { variantCode: 'ASC' },where:{isActive:true}
           });
         console.log(skuCodesEntities)
            if (skuCodesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                skuCodesEntities.forEach(skuCodeEntity => {
                    const convertedskuCodesDto: SkuCodesDTO = this.skuCodesAdapter.convertEntityToDto(
                      skuCodeEntity
                    );
                    skuCodesDTO.push(convertedskuCodesDto);
                });
                const response = new AllSkuResponseModel(true, 11108, "SkuCodes retrieved successfully", skuCodesDTO);
                // const newLogDto = new LogsDto(1,'view active sku codes', 'SkuCodes', 0, true, '','')
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return response;
            } else {
                throw new AllSkuResponseModel(false,99998, 'Data not found'); skuCodesDTO
            }
        } catch (err) {
            return err;
        }
    }


    /**
     * Activate or De-Activate Sku COde
     * @param skuCodesReq 
     */
    async activateOrDeactivateSkuCode(skuCodesReq: SkuCodesRequest): Promise<SkuResponseModel> {
        try {
            const skuCodeExists = await this.getSkuCodeById(skuCodesReq.skuCodeId);
            if (skuCodeExists) {
                if (skuCodesReq.versionFlag !== skuCodeExists.versionFlag) {
                    throw new SkuResponseModel(false,10113, 'Someone updated the current Sku Code information.Refresh and tryagain');
                } else {

                    const skuCodeStatus = await this.skuCodesRepository.update(
                        { skuCodeId: skuCodesReq.skuCodeId },
                        { isActive: skuCodesReq.isActive, updatedUser: skuCodesReq.updatedUser });

                    if (skuCodeExists.isActive) {
                        if (skuCodeStatus.affected) {
                            const skuCodeResponse: SkuResponseModel = new SkuResponseModel(true, 10115, 'Sku Code is de-activated successfully');
                            return skuCodeResponse;
                        } else {
                            throw new SkuResponseModel(false,10111, 'Sku Code is already deactivated');
                        }
                    } else {
                        if (skuCodeStatus.affected) {
                            const skuCodeResponse: SkuResponseModel = new SkuResponseModel(true, 10114, 'Sku Code is activated successfully');
                            return skuCodeResponse;
                        } else {
                            throw new SkuResponseModel(false,10112, 'Sku Code is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new SkuResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * get Sku Code by Id
     * @param skuCodeId 
     */
    async getSkuCodeById(skuCodeId: number): Promise<SkuCodes> {
        const Response = await this.skuCodesRepository.findOne({
            where: { skuCodeId: skuCodeId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    /**
     * 
     * @param skuCodeReq 
     * @returns 
     */
    async getValueAdditionDataBySkuCode(skuCodeReq: GetValueAdditionDataBySkuCodesRequest): Promise<CommonResponse> {
        const skuCodesEntities = await this.skuCodesRepository.createQueryBuilder("sku_codes")
            .select(["value_addition_one_types.name as valueAdd1Name,value_addition_one_types.code as valueAdd1code,value_addition_two_types.name as valueAdd2Name,value_addition_two_types.code as valueAdd2code,value_addition_three_types.name as valueAdd3Name,value_addition_three_types.code as valueAdd3code,value_addition_four_types.name as valueAdd4Name,value_addition_four_types.code as valueAdd4code,value_addition_five_types.name as valueAdd5Name,value_addition_five_types.code as valueAdd5code,food_types.food_type as foodType, sku_codes.sku_code_id as skuCodeId,sku_codes.value_addition_one_id as valueAdditionOneId,sku_codes.value_addition_two_id as valueAdditionTwoId,sku_codes.value_addition_three_id as valueAdditionThreeId,sku_codes.value_addition_four_id as valueAdditionFourId,sku_codes.value_addition_five_id as valueAdditionFiveId,sku_codes.food_type_id as foodTypeId,products.product_id as productId,products.name as productName,grades.grade_id as gradeId,grades.grade_min_count as minGrade,grades.grade_max_count as maxGrade,sku_codes.soaking_style as soakingStyle,sku_codes.soaking_time as soakingTime,sku_codes.required_count as requiredCount,sku_codes.min_glaze as minglaze,sku_codes.max_glaze as maxglaze,sku_codes.loss_or_gain_percentage as lossOrGainPercentage,unit_price as unitPrice"])
            .leftJoin("value_addition_one_types", "value_addition_one_types", "value_addition_one_types.value_addition_one_id = sku_codes.value_addition_one_id")
            .leftJoin("value_addition_two_types", "value_addition_two_types", "value_addition_two_types.value_addition_two_id = sku_codes.value_addition_two_id")
            .leftJoin("value_addition_three_types", "value_addition_three_types", "value_addition_three_types.value_addition_three_id = sku_codes.value_addition_three_id")
            .leftJoin("value_addition_four_types", "value_addition_four_types", "value_addition_four_types.value_addition_four_id = sku_codes.value_addition_four_id")
            .leftJoin("value_addition_five_types", "value_addition_five_types", "value_addition_five_types.value_addition_five_id = sku_codes.value_addition_five_id")
            .leftJoin("food_types", "food_types", "food_types.food_type_id = sku_codes.food_type_id")
            .leftJoin("products", "products", "products.product_id = sku_codes.product_id")
            .leftJoin("grades", "grades", "grades.grade_id = sku_codes.grade_id")
           .where(`sku_codes.sku_code_id = ${skuCodeReq.skuCodeId}`)
            .getRawOne();
            console.log(skuCodesEntities);
    if (skuCodesEntities) {
        const convertedskuCodesDto: SkuCodesDTO = this.skuCodesAdapter.convertDataToDto(skuCodesEntities);
        return new CommonResponse(true, 11108, "Sku Codes retrieved successfully", convertedskuCodesDto);
    } else {
        throw new CommonResponse(false,99998, 'Data not found');
    }
    }
    async getSkuDataById(@Body() skuCodeRequest:SkuCodesRequest): Promise<SkuResponseModel> {
        // const page: number = 1;
        try {
          const skuCodeDTO: SkuCodesDTO[] = [];
          //retrieves all companies
          const skuCodeEntities: SkuCodes = await this.skuCodesRepository.findOne({
            //   relations:["CusAddressInfo"],
            where:{skuCodeId:skuCodeRequest.skuCodeId}
            });
            
            const skuCodeData: SkuCodesDTO = this.skuCodesAdapter.convertEntityToDto(skuCodeEntities);
            if (skuCodeData) {
                const response = new SkuResponseModel(true, 11101 , 'variant code retrived Successfully',skuCodeData);
                return response;
            }
            else{
                throw new SkuResponseModel(false,11106,'Something went wrong');
            }
            // generating resposnse
            
        } catch (err) {
          return err;
        }
      }

      @LogActions()
      async getYieldPercentages (Req:SkuDataRequest):Promise<SkuPercentagesResponseModel> {
          const reqsoakingStyle = Req.soakingStyle;
          console.log(Req)
          let columnName ;
          if(reqsoakingStyle=='STPP+SALT'){
              columnName = 'sttpSalt';
          }
          if(reqsoakingStyle=='Only SALT'){
            columnName = 'onlySalt';
        }
        if(reqsoakingStyle=='NP + SALT'){
            columnName = 'npSalt';
        }
        if(reqsoakingStyle=='CP + SALT'){
            columnName = 'cpSalt';
        }
          const skuCodeData = await this.skuCodesRepository.findOne({
              where:{skuCodeId:Req.skuCodeId,foodTypeId:Req.foodTypeId}
            });
            
            if(skuCodeData != undefined){
                const response = new SkuPercentagesResponseModel(true,11247,'final percentage retrived',new SkuPercentageDto(skuCodeData.lossOrGainPercentage));
                console.log(response)
                return response;

            }else{
                return new SkuPercentagesResponseModel(false,11106,'no yield percentage added for selected soacking style');

            }
      }

     

      async createSkuDetails (skuDetails:SkuDetails,request: Request) : Promise<SkuDetailsResponseModel>{
        
          try{
              console.log('skuDetails');
              console.log(skuDetails);
              const skuData :number[] = skuDetails.multipleVarientCode;
              console.log('skuData');
              console.log(skuData);
              let result;
              const flagSet = new Set<boolean>()
            //   const data = await this.skudetailsRepo.count({where:{skuCodeId:skuDetails[0].skuCodeId}})
            //     if(data > 0){
            //      const deleteSku = await this.skudetailsRepo.delete({ skuCodeId : skuDetails[0].skuCodeId})
            //      if(!deleteSku.affected){
            //          throw new ErrorResponse(1111,'Somethimg went wrong in deletion of previous records')
            //      }
            //     }
              for(const iterator of skuData){
                  console.log('iterator')
                  console.log(iterator)
                
                    const entityObj = new SkuCodesDetail();
                    entityObj.skuCodeId = skuDetails.skuCodeId;
                    entityObj.multipleVarientCode = iterator;
                    entityObj.createdUser = skuDetails.createdUser;
                    entityObj.createdAt = skuDetails.createdAt;
                    result = await this.skudetailsRepo.save(entityObj)
                    console.log(result);
                    if(result){
                        flagSet.add(true)
                    }else{
                        flagSet.add(false)
                    }
              }
              if(!flagSet.has(false)){
                return new SkuDetailsResponseModel(true,11111,'Created Successfully')
              }else{
                return new SkuDetailsResponseModel(false,11111,'Something went wrong')
              }
              
          }catch(err){
            return new SkuDetailsResponseModel(false,11111,err)

          }

      }

      async getSkuConversions(req:SkuCodesRequest):Promise<CommonResponse>{
          const skuConvdata = await this.skudetailsRepo.createQueryBuilder("varient_code_conversion")
          .select('conversion_code_id as convVarId') 
          .where(`sku_code_id = ${req.skuCodeId}`) 
          .getRawMany()
          let varIds = []
          if(skuConvdata.length > 0){
              for(const item of skuConvdata){
                varIds.push(item.convVarId)
              }
              return new CommonResponse(true,5555,'Data retrievd',varIds)
          }else{
              return new CommonResponse(false,4444,'No data found',undefined)
          }
      }

      async getSkuCodeNamesForSkucodeId(skuCodeReq: GetValueAdditionDataBySkuCodesRequest): Promise<CommonResponse> {
        const skuCodesEntities = await this.skuCodesRepository.createQueryBuilder("sku_codes")
            .select(["value_addition_one_types.name as valueAdd1Name,value_addition_one_types.code as valueAdd1code,value_addition_two_types.name as valueAdd2Name,value_addition_two_types.code as valueAdd2code,value_addition_three_types.name as valueAdd3Name,value_addition_three_types.code as valueAdd3code,value_addition_four_types.name as valueAdd4Name,value_addition_four_types.code as valueAdd4code,value_addition_five_types.name as valueAdd5Name,value_addition_five_types.code as valueAdd5code,food_types.food_type as foodType, sku_codes.sku_code_id as skuCodeId,sku_codes.value_addition_one_id as valueAdditionOneId,sku_codes.value_addition_two_id as valueAdditionTwoId,sku_codes.value_addition_three_id as valueAdditionThreeId,sku_codes.value_addition_four_id as valueAdditionFourId,sku_codes.value_addition_five_id as valueAdditionFiveId,sku_codes.food_type_id as foodTypeId,products.product_id as productId,products.name as productName,grades.grade_id as gradeId,grades.grade_min_count as minGrade,grades.grade_max_count as maxGrade,sku_codes.soaking_style as soakingStyle,sku_codes.soaking_time as soakingTime,sku_codes.required_count as requiredCount,sku_codes.min_glaze as minglaze,sku_codes.max_glaze as maxglaze,sku_codes.loss_or_gain_percentage as lossOrGainPercentage,unit_price as unitPrice"])
            .leftJoin("value_addition_one_types", "value_addition_one_types", "value_addition_one_types.value_addition_one_id = sku_codes.value_addition_one_id")
            .leftJoin("value_addition_two_types", "value_addition_two_types", "value_addition_two_types.value_addition_two_id = sku_codes.value_addition_two_id")
            .leftJoin("value_addition_three_types", "value_addition_three_types", "value_addition_three_types.value_addition_three_id = sku_codes.value_addition_three_id")
            .leftJoin("value_addition_four_types", "value_addition_four_types", "value_addition_four_types.value_addition_four_id = sku_codes.value_addition_four_id")
            .leftJoin("value_addition_five_types", "value_addition_five_types", "value_addition_five_types.value_addition_five_id = sku_codes.value_addition_five_id")
            .leftJoin("food_types", "food_types", "food_types.food_type_id = sku_codes.food_type_id")
            .leftJoin("products", "products", "products.product_id = sku_codes.product_id")
            .leftJoin("grades", "grades", "grades.grade_id = sku_codes.grade_id")
           .where(`sku_codes.sku_code_id = ${skuCodeReq.skuCodeId}`)

            .getRawOne();
            console.log(skuCodesEntities);
    if (skuCodesEntities) {
       
        return new CommonResponse(true, 11108, "Sku Codes retrieved successfully", skuCodesEntities);
    } else {
        throw new CommonResponse(false,99998, 'Data not found');
    }
    }

    async getSkuCodesBySoakStyle(req:SoakTypeRequest): Promise<CommonResponse> {
        const manager = getManager()
        try {
            let infoQuery = `Select sku_code_id as skuCodeId, short_code as shortCode,g.grade_name as gradeName,soaking_time as soakingTime,soaking_style as soakingStyle from ${appSettings.masters_db} .sku_codes sku
            left join ${appSettings.masters_db} .food_types ft on ft.food_type_id = sku.food_type_id
            left join ${appSettings.masters_db} .grades g on g.grade_id = sku.grade_id
             where sku_code_id > 0`
            if(req.type == 'Soaked'){
                infoQuery += ` and soaking_style != 'NS'`
            }else if(req.type == 'Non Soaked'){
                infoQuery += ` and soaking_style = 'NS'`
            }else if(req.type == OperationTypeEnum.COOKING){
                infoQuery += ` and ft.food_type != 'RAW'`
            }
            const info = await manager.query(infoQuery)
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retrieved',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }


}
